<template>
  <div id="app">
    <v-container fluid grid-list-md>
      <p-loader></p-loader>
      <p-snackbar></p-snackbar>
      <v-toolbar app dark color="primary" style="z-index: 5">
        <v-spacer></v-spacer>

        <v-toolbar-title class="white--text">Modo Offline</v-toolbar-title>

        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn icon slot="activator" @click="reloadPage()"><v-icon>replay</v-icon></v-btn>
          <span>Atualizar página</span>                  
        </v-tooltip>
      </v-toolbar>
      <v-layout align-center justify-center fill-height>
          <router-view/>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  /* eslint-disable template-curly-spacing */
  import PLoader from './../shared/PLoader'
  import PSnackbar from './../shared/PSnackbar'

  export default {
    name: 'shared',
    components: {PSnackbar, PLoader},
    created () {
      if (navigator.onLine) {
        this.$router.push('/home')
      }
    },
    methods: {
      reloadPage () {
        location.reload(true)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/Offline.vue